import { FireOutbreakReactionEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireOutbreakReaction } from './FireOutbreakReaction.abstract'
import i18n from '@/VueI18n'

export class OccurredFireOutbreakOptionStrategy extends FireOutbreakReaction {
	constructor() {
		super(
			i18n.t('fireRiskDashboardReactionPositive') as string,
			'material-symbols:thumb-up-rounded',
			FireOutbreakReactionEnum.POSITIVE,
		)
	}
}
